module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapter-number---IVP",
    attrs: {
      "title": "Dedication"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagev",
      "title": "v"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("For Aaron and Amy,")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("through whose eyes I learned to see myself as more than a divine typo.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevi",
      "title": "vi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a1bb6fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/04_dedication.vue
// module id = 60
// module chunks = 0